module.exports = __webpack_public_path__ + "img/加.973c51d1.svg";